import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Icon, StepsIndicator, RouterLink } from '../../components/ui';
import './Cart.scss';

import cartSlice, { getCart } from '../../store/slices/cart.slice';
import Order from '../../store/interfaces/order.interface';
import { Modal } from 'react-bootstrap';

const Cart = () => {
  const { orders } = useSelector(getCart);
  const dispatch = useDispatch();
  const [total, setTotal] = useState(0);
  const [removeOrder, setRemoveOrder] = useState(null);
  useEffect(() => {
    setTotal(getTotal());
  }, [orders]);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setRemoveOrder(null);
    setShow(false);
  };
  const handleShow = (e: React.MouseEvent<HTMLElement>, index: any) => {
    e.preventDefault();
    setRemoveOrder(index);
    setShow(true);
  };

  const getTotal = () => {
    return orders.reduce(
      (a, b) =>
        a + ((b.frame?.price || 0) + (b.lensType?.lensPackage?.addOnPrice || 0)) * (b.qty || 0),
      0,
    );
  };

  const removeOrderItem = () => {
    dispatch(cartSlice.actions.deleteOrder(removeOrder));
    setTotal(getTotal());
    setShow(false);
  };

  const incQty = (e: React.MouseEvent<HTMLElement>, index: number) => {
    e.preventDefault();
    dispatch(cartSlice.actions.incQty(index));
    setTotal(getTotal());
  };

  const decQty = (e: React.MouseEvent<HTMLElement>, index: number) => {
    e.preventDefault();
    dispatch(cartSlice.actions.decQty(index));
    setTotal(getTotal());
  };
  // removeOrderItem(e, index)
  return (
    <div className="template-cart">
      {orders?.length ? <StepsIndicator count={3} step={1}></StepsIndicator> : ''}
      {orders?.length ? <h1 className="header">CART</h1> : ''}
      <div className="wrapper">
        {orders?.length === 0 ? (
          <h1 className="text heading">Your shopping cart is empty.</h1>
        ) : (
          <>
            <div className="cart-items">
              <ul>
                {orders.map((o, index) => (
                  <li>
                    <div className="column remove">
                      <a
                        href="/"
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                          handleShow(e, index);
                        }}
                      >
                        <Icon className="close-btn" imgPath="/images/icons/close-btn.png"></Icon>
                      </a>
                    </div>
                    <div className="column image">
                      <img src={o.frame?.previews[0]} alt="" />
                    </div>
                    <div className="column details">
                      <ul>
                        <li>
                          <div className="column column1">
                            <h3>{o.frame?.modelName}</h3>
                          </div>
                          <div className="column column2">${o.frame?.price?.toFixed(2)}</div>
                        </li>
                        <li>
                          <div className="column column1">
                            {o.lensType?.lensPackage?.name || o.lensType?.lensPackage?.title}
                          </div>
                          <div className="column column2">
                            ${o.lensType?.lensPackage?.addOnPrice?.toFixed(2)}
                          </div>
                        </li>
                        <li>
                          <div className="column column1">
                            <span className="label">Quantity:</span>
                            <a
                              className={o.qty === 1 ? 'qty dec disabled' : 'qty dec'}
                              href="/"
                              onClick={(e: React.MouseEvent<HTMLElement>) => {
                                decQty(e, index);
                              }}
                            >
                              -
                            </a>
                            <span className="value">{o.qty}</span>
                            <a
                              className="qty inc"
                              href="/"
                              onClick={(e: React.MouseEvent<HTMLElement>) => {
                                incQty(e, index);
                              }}
                            >
                              +
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="column column1">
                            <RouterLink path={`/eyeglasses/${o.frame?.code}?orderId=${o.id}`}>
                              FILL YOUR PRESCRIPTION
                            </RouterLink>
                          </div>
                          <div className="column column2">
                            $
                            {(
                              ((o.lensType?.lensPackage?.addOnPrice || 0) + (o.frame?.price || 0)) *
                              (o.qty || 0)
                            ).toFixed(2)}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="total">
              Total: <strong>${total.toFixed(2)}</strong>
            </div>
            <div className="cta-container">
              <Button path="/eyeglasses">Continue Shopping</Button>
              <Button className="button secondary-button" path="/checkout">
                Proceed Checkout
              </Button>
            </div>
          </>
        )}
      </div>

      <Modal show={show} backdrop="static" onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>visionhub.confirm.removecart?</Modal.Body>
        <Modal.Footer>
          <Button click={handleClose}>Cancel</Button>
          <Button className="button secondary-button" click={removeOrderItem}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Cart;
